

export const GET_USER_SUCCESS = "GET_USER_SUCCESS";
export const GET_USER_FAIL = "GET_USER_FAIL";
export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS";
export const CREATE_USER_FAIL = "CREATE_USER_FAIL";
export const EDIT_PROFILE_SUCCESS = "EDIT_PROFILE_SUCCESS";
export const EDIT_PROFILE_FAIL = "EDIT_PROFILE_FAIL";
export const DISABLE_USER_SUCCESS = "DISABLE_USER_SUCCESS";
export const DISABLE_USER_FAIL = "DISABLE_USER_FAIL";
export const ENABLE_USER_SUCCESS = "ENABLE_USER_SUCCESS";
export const ENABLE_USER_FAIL = "ENABLE_USER_FAIL";
export const DISABLE_CLIENT_SUCCESS = "DISABLE_CLIENT_SUCCESS";
export const DISABLE_CLIENT_FAIL = "DISABLE_CLIENT_FAIL";
export const ENABLE_CLIENT_SUCCESS = "ENABLE_CLIENT_SUCCESS";
export const ENABLE_CLIENT_FAIL = "ENABLE_CLIENT_FAIL";

export const GET_CLIENT_SUCCESS = "GET_CLIENT_SUCCESS";
export const GET_CLIENT_FAIL = "GET_CLIENT_FAIL";
export const CREATE_CLIENT_SUCCESS = "CREATE_CLIENT_SUCCESS";
export const CREATE_CLIENT_FAIL = "CREATE_CLIENT_FAIL";
export const EDIT_CLIENT_SUCCESS = "EDIT_CLIENT_SUCCESS";
export const EDIT_CLIENT_FAIL = "EDIT_CLIENT_FAIL";
export const DELETE_CLIENT_SUCCESS = "DELETE_CLIENT_SUCCESS";
export const DELETE_CLIENT_FAIL = "DELETE_CLIENT_FAIL";

export const GETALL_USERS_SUCCESS = "GETALL_USERS_SUCCESS";
export const GETALL_USERS_FAIL = "GETALL_USERS_FAIL";
export const GETALL_CLIENTS_SUCCESS = "GETALL_CLIENTS_SUCCESS";
export const GETALL_CLIENTS_FAIL = "GETALL_CLIENTS_FAIL";


export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_FAIL = "FORGOT_PASSWORD_FAIL";
export const CONFIRM_EMAIL_SUCCESS = "CONFIRM_EMAIL_SUCCESS";
export const CONFIRM_EMAIL_FAIL = "CONFIRM_EMAIL_FAIL";

export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_FAIL = "CHANGE_PASSWORD_FAIL";

export const LOGOUT = "LOGOUT";
export const GET_DOMAINS = "GET_DOMAINS";

export const SET_MESSAGE = "SET_MESSAGE";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";

export const SEND_AAD_INVITE_FAIL = "SEND_AAD_INVITE_FAIL";
export const SEND_AAD_INVITE_SUCCESS = "SEND_AAD_INVITE_SUCCESS";

